module.exports = __webpack_public_path__ + "img/campfire.d37c18db.svg";